const config = {
  development: {
    API_URL: process.env.REACT_APP_API_URL_DEV || 'http://localhost:8080',
    API_BASE_URL: process.env.REACT_APP_API_URL_DEV || 'http://localhost:8080',
    api: {
      baseURL: process.env.REACT_APP_API_URL_DEV || 'http://localhost:8080',
    },
    apiUrl: process.env.REACT_APP_API_URL_DEV || 'http://localhost:8080',
    auth0: {
      domain: process.env.REACT_APP_AUTH0_DOMAIN,
      clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
      redirectUri:
        process.env.REACT_APP_AUTH0_REDIRECT_URI || 'http://localhost:3000',
      audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'api.rely.business',
    },
    stripe: {
      publicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    },
  },
  staging: {
    API_URL: 'https://api-dev.rely.business',
    API_BASE_URL: 'https://api-dev.rely.business',
    api: {
      baseURL: 'https://api-dev.rely.business',
    },
    apiUrl: 'https://api-dev.rely.business',
    auth0: {
      domain: process.env.REACT_APP_AUTH0_DOMAIN,
      clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
      redirectUri: 'https://app-dev.rely.business',
      audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'api.rely.business',
    },
    stripe: {
      publicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    },
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL_PROD || 'https://api.rely.business',
    API_BASE_URL:
      process.env.REACT_APP_API_URL_PROD || 'https://api.rely.business',
    api: {
      baseURL:
        process.env.REACT_APP_API_URL_PROD || 'https://api.rely.business',
    },
    apiUrl: process.env.REACT_APP_API_URL_PROD || 'https://api.rely.business',
    auth0: {
      domain: process.env.REACT_APP_AUTH0_DOMAIN,
      clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
      redirectUri:
        process.env.REACT_APP_AUTH0_REDIRECT_URI || 'https://app.rely.business',
      audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'api.rely.business',
    },
    stripe: {
      publicKey:
        process.env.REACT_APP_STRIPE_PUBLIC_KEY_LIVE ||
        process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    },
  },
};

// Detect environment based on hostname at runtime
const getEnvironment = () => {
  // Check if we're in a browser
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // Dev/staging environment
    if (hostname === 'app-dev.rely.business' || hostname.includes('app-dev')) {
      return 'staging';
    }

    // Production
    if (hostname === 'app.rely.business') {
      return 'production';
    }

    // Cloudflare Pages preview deployments
    if (hostname.endsWith('.pages.dev')) {
      return 'staging';
    }
  }

  // Fallback to NODE_ENV
  return process.env.NODE_ENV || 'development';
};

const environment = getEnvironment();

const environmentConfig = {
  ...config[environment],
};

export default environmentConfig;
